import React from 'react';
import About from './About/About';
import Contact from './Contact/Contact';
import Home from './Home/Home';
import Service from './Service/Service';



const Homepage = ()=>{
    return(
        <>
        <Home/>
        <About/>
        <Service/>
        <Contact/>
        </>

    );
}
export default Homepage;